import { useQuery } from "react-query";

import { api } from "../api";

export type Template = {
  id: string;
  title: string;
  body: string;
  version: number;
  template: string;
  is_active: boolean;
};

export async function getTemplates(): Promise<Template[]> {
  const response = await api.get<any>("/templates");

  const { data } = response;

  const templates = data.map((template: Template) => {
    return {
      ...template
    };
  });

  return templates;
}

export function useTemplates() {
  return useQuery(["templates"], () => getTemplates(), {
    staleTime: 1000 * 10, // 10 seconds
  });
}
